import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewState } from '../biz-grid-viewstate';
import { FormsModule } from '@angular/forms';
import { BizGridNotInListDirective } from '../biz-grid-not-in-list.directive';


@Component({
    templateUrl: './biz-grid-save-dialog.component.html',
    styleUrls: ['./biz-grid-save-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, BizGridNotInListDirective]
})
export class BizGridSaveDialogComponent implements OnInit {
  private modal = inject(NgbActiveModal);

  public viewStates: ViewState[];
  public viewState: ViewState;
  public viewStateWithTrackingFields: boolean;

  ngOnInit(): void {
  }

  getUsedViewStateNames(): string[] {
    return this.viewStates
      .filter(e => this.viewState.Name.localeCompare(e.Name) !== 0)
      .map(e => e.Name);
  }

  ok(formData: any): void {
    const viewState = {
      ...this.viewState,
      Name: formData.name || '',
      ShowTrackingFields: formData.showTrackingFields || false
    };
    this.modal.close(viewState);
  }

  cancel(): void {
    this.modal.dismiss();
  }
}
